// extracted by mini-css-extract-plugin
export default {"mainProfile":"profile_mainProfile__7u3L0","superiorLink":"profile_superiorLink__CWALv","section":"profile_section__SqzIM","profileGrid":"profile_profileGrid__43H1D"};